
import { FormControlLabel, Grid, Radio, RadioGroup, Typography, Paper } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import { observer } from "mobx-react";
import { useDrawsStore } from "../hooks";
import { useEffect } from "react";
import { useUserStore } from "@roc/feature-app-core";

const useStyles = makeStyles(theme => ({
  paper: {
    padding: 24,
    width: '100%',
  },
  container: {
    padding: 16,
  }
}));
const DrawSubTypeSelection = observer(({ showInsuranceType}) => {
  const { userStore } = useUserStore();
  const { pointOfContactStore } = useDrawsStore();
  const formFields = pointOfContactStore.pointOfContactFormStore.form.fields;

  const handleFormChange = (e) => {
    pointOfContactStore.setIsSoftCostOnlyDraw(e.target.value === 'soft costs');
    pointOfContactStore.pointOfContactFormStore.onFieldChange('drawSubType', e.target.value);
  }
  useEffect(() => {
  }, []);

  const classes = useStyles();

  return (
    <Grid item container xs={12} md={6} className={classes.container}>
      <Paper className={classes.paper}>
        <Grid container direction="column" item>
          <Grid item container direction='row' justifyContent='space-between'>
            <Grid item>
              <Typography variant="h6">
                DRAW TYPE
              </Typography>
            </Grid>
          </Grid>
          <Grid item>
            <Typography variant="caption" color="textSecondary">
              What type of work has been completed so far?
            </Typography>
          </Grid>
        </Grid>
        <Grid container direction="column">
          <Grid item xs={12} sm={12}>
            <RadioGroup value={formFields.drawSubType.value} onChange={e => handleFormChange(e)}>
              <FormControlLabel value="soft costs" control={<Radio />} label="Soft Costs" />
              <FormControlLabel value="hard costs" control={<Radio />} label="Hard Costs" />
              <FormControlLabel value="hard & soft costs" control={<Radio />} label="Hard & Soft Costs" />
              {!!showInsuranceType && (
                <FormControlLabel value="insurance" control={<Radio />} label="Insurance" />
              )}
            </RadioGroup>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  )
});

export default DrawSubTypeSelection;